import React from 'react';
import { Form } from 'antd';
import WizardForm from '@severalnines/bar-frontend-components/build/lib/Navigation/WizardForm';
import WizardFormConfiguration from '@severalnines/bar-frontend-components/build/lib/Navigation/Wizard/WizardFormConfiguration';
import CcCluster from '../../../../services/models/CcCluster';
import { FormInstance } from 'antd/lib/form';
import useCreateJob from '../../../Jobs/useCreateJob';
import { CmonJobInstanceCommand } from '../../../../services/cmon/models/CmonJobInstance';
import ImportMaxScaleWhere, {
    getImportMaxScaleWhereValidation,
} from './ImportMaxScaleWizardFormSteps/ImportMaxScaleWhere';
import ImportMaxScalePreview from './ImportMaxScaleWizardFormSteps/ImportMaxScalePreview';

export enum MaxScaleFormSteps {
    WHERE_TO_INS = 'WhereToInstall',
    PREVIEW = 'preview',
}

export type ImportMaxScaleWizardFormProps = {
    onCancel?: () => void;
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onStepErrorInsist?: (err: Error) => void;
    onTouchedChange?: (touched: boolean) => void;
    cluster?: CcCluster;
};

export default ImportMaxScaleWizardForm;

function ImportMaxScaleWizardForm({
    onCancel,
    onSuccess,
    onStepErrorInsist,
    onTouchedChange,
    onError,
    cluster,
}: ImportMaxScaleWizardFormProps) {
    const [form] = Form.useForm();

    const { loading, send } = useCreateJob({
        clusterId: cluster?.clusterId,
        title: 'Register MaxScale',
        command:
            CmonJobInstanceCommand.MAXSCALE.toLowerCase() as CmonJobInstanceCommand,
        onSuccess,
    });

    const handleSubmit = async () => {
        try {
            const { maxScaleWhere } = form.getFieldsValue(true);
            const [address] = maxScaleWhere.address;
            await send(
                {
                    clusterId: cluster?.clusterId,
                    ...formatFields(form),
                },
                {
                    job: {
                        title: `Register MaxScale ${address?.extraData.hostname}`,
                    },
                }
            );
        } catch (err: any) {
            if (onError) {
                onError(err);
            }
        }
    };

    return (
        <WizardFormConfiguration
            form={form}
            onSubmit={handleSubmit}
            loading={loading}
            onCancel={onCancel}
            onStepErrorInsist={onStepErrorInsist}
            onTouchedChange={onTouchedChange}
            steps={[
                <WizardForm.Step
                    key={MaxScaleFormSteps.WHERE_TO_INS}
                    title="Where to install"
                    subTitle=" "
                    validate={getImportMaxScaleWhereValidation(form)}
                >
                    <ImportMaxScaleWhere
                        selectedCluster={cluster}
                        form={form}
                    />
                </WizardForm.Step>,
                <WizardForm.Step
                    key={MaxScaleFormSteps.PREVIEW}
                    title="Preview"
                    subTitle=" "
                >
                    <ImportMaxScalePreview form={form} />
                </WizardForm.Step>,
            ]}
        />
    );
}

export function formatFields(form: FormInstance) {
    const { maxScaleWhere } = form.getFieldsValue(true);
    const [address] = maxScaleWhere.address;
    const date = {
        action: 'register',
        node: {
            hostname: address?.extraData.hostname,
        },
    };
    return date;
}
